// Check if the document has loaded before running the script
document.addEventListener("DOMContentLoaded", function () {
    // Check if the elements with the class '.image-with-text__video' exist
    const targetElements = document.querySelectorAll('.image-with-text__video');
    
    if (targetElements.length > 0) {
      // Function to handle intersection events
      console.log("did we get to part 1")
      function handleIntersection(entries, observer) {
        console.log("did we get to part 2")
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const video = entry.target.querySelector('video');
            console.log(video)
            if (video) {
              video.play();
            }
          
          }
        });
      }
  
      // Create an Intersection Observer instance
      const options = {
        root: null, // Use the viewport as the root
        rootMargin: '0px',
        threshold: 0.5, // Fire when at least 50% of the element is visible
      };
  
      const observer = new IntersectionObserver(handleIntersection, options);
  
      // Start observing each target element
      targetElements.forEach(element => {
        observer.observe(element);
      });
    }
  });